import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PromotionHeader } from '../views/models/promotion.model';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {

  promotions: BehaviorSubject<PromotionHeader[]> = new BehaviorSubject([]);

  constructor(
    private http: HttpClient
  ) { }

  getPromotions(): Promise<PromotionHeader[]> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.baseURL + '/v2/api/promotions').subscribe({
        next: (resp: PromotionHeader[]) => {
          this.promotions.next(resp);
          resolve(resp);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  postPromotion(data: PromotionHeader): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post(environment.baseURL + '/v2/api/promotion', data).subscribe({
        next: (resp: PromotionHeader[]) => {
          this.getPromotions();
          resolve(true);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  deletePromotion(promotionId: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete(environment.baseURL + '/v2/api/promotion/' + promotionId).subscribe({
        next: (resp: PromotionHeader[]) => {
          this.getPromotions();
          resolve(true);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

}
